/**
 * Creates objects that are either Storage objects or respond to the same
 * methods that Storage objects do.
 * @constructor
 */
Foundation.Storable.WebStorageAbstractFactory = function () {
  /**
   * @private
   * @type {Storage|Foundation.Storable.WebStorageEmulator}
   */
  this._localStorage =
    Foundation.Storable.WebStorageAbstractFactory._determineStorageObject(window["localStorage"]);

  /**
   * @private
   * @type {Storage|Foundation.Storable.WebStorageEmulator}
   */
  this._sessionStorage =
    Foundation.Storable.WebStorageAbstractFactory._determineStorageObject(window["sessionStorage"]);
}

/**
 * Return the appropriate web storage object given either window.localStorage
 * or window.sessionStorage.
 * @private
 * @param {Storage?} storageObject
 * @return {Storage|Foundation.Storable.WebStorageEmulator}
 */
Foundation.Storable.WebStorageAbstractFactory._determineStorageObject = function (storageObject) {
  if (storageObject) {
    // This environment might support HTML5 Web Storage. Let's double check.
    var Storage = window["Storage"];
    if (Storage && storageObject instanceof Storage) {
      // Seems like we've got HTML5 Web Storage support, but the user may
      // have disabled this. Let's see if we're really allowed to write to
      // it before we commit to using it.
      try {
        var testItemName = "Foundation.Storable.WebStorageAbstractFactory._test";
        storageObject.setItem(testItemName, "foo");
        if (storageObject.getItem(testItemName) === "foo") {
          storageObject.removeItem(testItemName);
          return storageObject;
        }
      }
      catch (e) {
        Foundation.warn("HTML5 WebStorage disabled or full?");
      }
    }
  }

  // If we got to this point then this environment doesn't seem to support
  // HTML5 Web Storage.
  return new Foundation.Storable.WebStorageEmulator();
}


/**
 * WebStorageAbstractFactory singleton.
 * @return {Foundation.Storable.WebStorageAbstractFactory}
 */
Foundation.Storable.WebStorageAbstractFactory.sharedInstance = function () {
  if (!Foundation.Storable.WebStorageAbstractFactory._instance) {
    Foundation.Storable.WebStorageAbstractFactory._instance
      = new Foundation.Storable.WebStorageAbstractFactory();
  }
  return Foundation.Storable.WebStorageAbstractFactory._instance;
}

/**
 * Return the object used for local storage.
 * @return {Storage|Foundation.Storable.WebStorageEmulator}
 */
Foundation.Storable.WebStorageAbstractFactory.prototype.localStorageObject = function () {
  return this._localStorage;
}

/**
 * Return the object used for local storage.
 * @return {Storage|Foundation.Storable.WebStorageEmulator}
 */
Foundation.Storable.WebStorageAbstractFactory.prototype.sessionStorageObject = function () {
  return this._sessionStorage;
}
